import { Div, Image } from "@tblabs/truffle";


export class Loader extends Div
{
    constructor(text: string = "Ładowanie...")
    {
        super();
        this.Style("display: flex; align-items: center; gap: 8px; justify-content: center;")

        this.Append(
            new Image("spinner.gif").Width(32).Height(32),
            text,
        )
    }
}
